import React from "react";
import AccountProfile from "@/components/app/AccountProfile";

export default function VendorProfile() {
  return <AccountProfile testId="vendor-profile" subtitle="Your name, email, mobile number and password. You sign in with your email." />;
}
